// extracted by mini-css-extract-plugin
export default {"topBar":"TopBar_topBar__nE7u5","title":"TopBar_title__Wn9sm","icon":"TopBar_icon__XPx5g","settings":"TopBar_settings__EvVRr","github":"TopBar_github__7Ubbo"};